import { axiosInstance } from 'services/http';

interface ISendVerificationCode {
  regionId: string;
}
export interface UserInterface {
  id: string;
  firstName: string;
  lastName: string;
}
export interface UserInterfaceResponse {
  data: {
    data: UserInterface[];
  };
}

export const getSupervisors = ({
  regionId,
}: ISendVerificationCode): Promise<UserInterfaceResponse> => {
  const filter = `?limit=150&page=1&filter=userRoles.role.name%7C%7C$eq%7C%7CRegionalManager&filter=userRegions.regionId%7C%7C$eq%7C%7C${regionId}&join=userRegions&join=userRoles&join=userRoles.role`;
  return axiosInstance.get('/user' + filter);
};

export const getSupervisorsOnly = ({
  regionId,
}: ISendVerificationCode): Promise<UserInterfaceResponse> => {
  const filter = `?limit=150&page=1&filter=userRoles.role.name%7C%7C$eq%7C%7CSupervisor&filter=active%7C%7C$eq%7C%7Ctrue&&sort=firstName,ASC&filter=userRegions.regionId%7C%7C$eq%7C%7C${regionId}&join=userRegions&join=userRoles&join=userRoles.role`;
  return axiosInstance.get('/user' + filter);
};

export const getBuilderSupervisors = (
  regionId,
): Promise<UserInterfaceResponse> => {
  const filter = `?limit=300&page=1&filter=userRoles.role.name%7C%7C$eq%7C%7CBuilderSupervisor&&sort=firstName,ASC&filter=userRegions.regionId%7C%7C$eq%7C%7C${regionId}&join=userRegions&join=userRoles&join=userRoles.role`;
  return axiosInstance.get('/user' + filter);
};
